<template>
  <ResizableColumns identifier="dashboard" :first-column-min-size="30" :first-column-default-size="35">
    <template #first-column>
      <DevicesCard ref="devicesCard"
          :selected-device-id="selectedDeviceId"
          :filtered-devices="filteredDevices"
          @on-select-device="onCardSelectDevice"
      />
    </template>
    <template #second-column>
      <QuickMapCard ref="mapRef"
                    :filtered-devices="filteredDevices"
                    :selected-device-id="selectedDeviceId"
                    :search-token="searchToken"
                    @on-select-device="onSelectDevice"/>
    </template>
  </ResizableColumns>
</template>

<script>
import DevicesCard from '@/components/pages/dashboard/DevicesCard.vue';
import QuickMapCard from '@/components/pages/dashboard/QuickMapCard.vue';
import ResizableColumns from "@/components/pages/partials/ResizableColumns.vue";
import {dataAggregator, entityDataManager} from "@/assets/js/data-manipulation";
import {mapGetters, mapState} from "vuex";

export default {
  components: {QuickMapCard, DevicesCard, ResizableColumns},
  name: 'Dashboard',
  props: {
    searchToken: String,
  },
  data() {
    return {
      selectedDeviceId: null,
    };
  },
  computed: {
    ...mapState(['devices', 'groups', 'vehicles']),
    ...mapGetters(['isGroupShown', 'dashboardDeviceColumns']),
    filteredDevices() {
      return this.searchToken === ''
          ? this.mappedDevices
          : dataAggregator.filterDevicesByToken(this.mappedDevices, this.searchToken);
    },
    mappedDevices() {
      return entityDataManager.mapDashboardDevices(
          this.devices,
          this.groups,
          this.vehicles,
          this.dashboardDeviceColumns,
          this.isGroupShown);
    },
  },
  methods: {
    onCardSelectDevice(selectedDeviceId) {
      const focusSelectedDevice = this.selectedDeviceId !== null;

      this.onSelectDevice(selectedDeviceId);

      if (focusSelectedDevice) {
        this.$refs.mapRef.focusSelectedDevice();
        this.$refs.mapRef.openSelectedDeviceInfoWindow();
        setTimeout(() => this.$refs.mapRef.centerSelectedDevice());
      }
    },
    onSelectDevice(selectedDeviceId) {
      this.selectedDeviceId = selectedDeviceId;
    },
    getGroupName(device) {
      return entityDataManager.getById(this.groups, device.groupId)?.name ?? '';
    },
  },
};
</script>
